import React from 'react';
import { Navbar } from './components/Navbar';
import { WaitlistHero } from './components/WaitlistHero';
import { ValueProps } from './components/ValueProps';
import { HowItWorks } from './components/HowItWorks';
import { WaitlistCTA } from './components/WaitlistCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-[#0F1B2D] text-slate-900 font-sans selection:bg-[#E8531E] selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <WaitlistHero data-id="element-3" />
        <ValueProps data-id="element-4" />
        <HowItWorks data-id="element-5" />
        <WaitlistCTA data-id="element-6" />
      </main>
      <Footer data-id="element-7" />
    </div>;
}